appSocial.factory('TokenInterceptor', ['$injector', function ($injector) {
    return {
        'request': function (config) {
            // skip non social requests
            if (!/social/.test(config.url)) {
                return config;
            }

            config.headers = config.headers || {};

            /**
             * @type SocialUserService
             */
            const userService = $injector.get('SocialUserService');
            const user = userService.get();

            if (user && user.loggedIn && user.token.length) {
                config.headers.token = user.token;
            }
            return config;
        },
    };
}]);
